import { sleep } from '@getstep/sdk/dist/util/Sleep'
import noop from 'lodash/noop'
import { useRef } from 'react'

import { useEffectAsync } from './useEffectAsync'

export const useInterval = (
    callback: () => Promise<void>,
    { maxRetries, isEnabled, interval }: UseIntervalOptions,
) => {
    const times = useRef(maxRetries)
    const promiseQueue = useRef(Promise.resolve())

    const execute = async () => {
        times.current -= 1

        if (!isEnabled()) return

        if (times.current > 0) {
            const resultPromise = promiseQueue.current.then(() => callback())
            promiseQueue.current = resultPromise.then(noop).catch(noop)
            await sleep(interval)
            await execute()
        }
    }

    useEffectAsync(execute, [interval])
}

interface UseIntervalOptions {
    interval: number
    maxRetries: number
    isEnabled: () => boolean
}
